import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';

const Button = styled.button`
  border: none;
  outline: none;
  border-radius: 3px;
  background-color: #0079ff;
  color: #fff;
  font-size: 14px;
  line-height: 16px;
  padding: 11px 42px;
  cursor: pointer;
  margin-bottom: ${props => (props.lmargin ? '60px' : '40px')};
`;

const CenteredButton = props => {
  return (
    <Button
      {...props}
      onClick={() => window.clickButton('b24-web-form-popup-btn-26')}
    >
      <FormattedMessage
        id="shop.block.button"
        defaultMessage="Создать магазин"
      />
    </Button>
  );
};

export default CenteredButton;
